"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var RefundData_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefundData = void 0;
/* eslint-disable eqeqeq */
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const uuid_1 = require("uuid");
const statusGetter_1 = require("../statusGetter");
const PaymentType_1 = require("./PaymentType");
const SimpleCustomer_1 = require("./SimpleCustomer");
let RefundData = RefundData_1 = class RefundData {
    _id = (0, uuid_1.v4)();
    paymentId;
    orderId;
    bookingReference;
    amount;
    gatewayId;
    type;
    description;
    createdAt = new Date();
    fulfilledAt;
    failedAt;
    customer;
    createdBy;
    creator;
    get status() {
        return (0, statusGetter_1.statusGetter)(this, RefundData_1, legacy_enums_1.ChargebackStatus);
    }
    static statusPrototype(status) {
        const defined = new Date();
        switch (status) {
            case legacy_enums_1.ChargebackStatus.Failed:
                return {
                    failedAt: defined,
                };
            case legacy_enums_1.ChargebackStatus.Fulfilled:
                return {
                    failedAt: undefined,
                    fulfilledAt: defined,
                };
            case legacy_enums_1.ChargebackStatus.Pending:
            default:
                return {
                    failedAt: undefined,
                    fulfilledAt: undefined,
                };
        }
    }
};
exports.RefundData = RefundData;
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RefundData.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((c) => (0, utils_1.isUndefinedOrNull)(c.orderId)),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RefundData.prototype, "paymentId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((c) => (0, utils_1.isUndefinedOrNull)(c.paymentId)),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RefundData.prototype, "orderId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.ValidateIf)((c) => !!c.orderId),
    __metadata("design:type", String)
], RefundData.prototype, "bookingReference", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], RefundData.prototype, "amount", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((p) => p.type == PaymentType_1.PaymentType.Mangopay || p.type == PaymentType_1.PaymentType.Paypal),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RefundData.prototype, "gatewayId", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], RefundData.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((c) => c.type == PaymentType_1.PaymentType.Other),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RefundData.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value))),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], RefundData.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value))),
    __metadata("design:type", Date)
], RefundData.prototype, "fulfilledAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value))),
    __metadata("design:type", Date)
], RefundData.prototype, "failedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.ValidateIf)((c) => !!c.orderId),
    __metadata("design:type", SimpleCustomer_1.SimpleCustomer)
], RefundData.prototype, "customer", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RefundData.prototype, "createdBy", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.ValidateIf)((c) => !!c.createdBy),
    __metadata("design:type", SimpleCustomer_1.SimpleCustomer)
], RefundData.prototype, "creator", void 0);
exports.RefundData = RefundData = RefundData_1 = __decorate([
    (0, class_transformer_1.Exclude)()
], RefundData);
//# sourceMappingURL=RefundData.js.map